import { Tour } from "../TourProvider.types";

export const TourProjectSharing: Tour = {
  name: "Project Access & Sharing",
  pages: ["projectHome"],
  conditions: { isProjectAdmin: true, isPersonalSpace: false },
  description:
    "Learn how to set access controls and permissions for your project.",
  steps: [
    {
      anchorId: "projectAccess",
      title: "Project Access Settings",
      content:
        "Use this tab to set access levels for your organization and individual members, or grant view-only access to people outside your organization.",
    },
    {
      anchorId: "organization-access-settings",
      title: "Set organization access",
      content: `Use this to set a default access level for all members of your organization. If you would prefer to keep it private or only invite select members, leave this as “restricted”`,
    },
    {
      anchorId: "individual-access-settings",
      title: "Set individual access",
      content:
        "Invite individual members of your organization and set their access level here.",
    },
    {
      anchorId: "external-access-settings",
      title: "Set external access",
      content:
        "If you would like to invite people to view this project who are not part of your organization, you can add them by email here. If they do not have an account, they will be sent a link to create one.",
    },
  ],
};
